import { AssetResponse } from 'src/common/helpers/file-upload';
import { CONTENT_TYPE_FILE, CONTENT_TYPE_IMAGE, CONTENT_TYPE_PDF, CONTENT_TYPE_VIDEO } from 'src/editor/constants';

export const getContentParamsByAsset = (
  asset: AssetResponse
): {
  contentType: string;
  payload: object;
} => {
  const payload = {
    content_name: asset.name,
    content_type: asset.type,
    name: asset.name,
    url: asset.url,
  };

  if (asset.type.startsWith('video')) {
    return {
      contentType: CONTENT_TYPE_VIDEO,
      payload: {
        video_name: asset.name,
        video_uuid: asset.uuid,
        node_type: CONTENT_TYPE_VIDEO,
        is_mobile_optimized: false,
        ...payload,
      },
    };
  }

  if (asset.type.endsWith('pdf')) {
    return {
      contentType: CONTENT_TYPE_PDF,
      payload: {
        s3_key: asset.s3_key,
        ...payload,
      },
    };
  }

  if (asset.type.startsWith('image')) {
    return {
      contentType: CONTENT_TYPE_IMAGE,
      payload,
    };
  }

  return {
    contentType: CONTENT_TYPE_FILE,
    payload: {
      s3_key: asset.s3_key,
      link_title: '',
      link_description: '',
      hide_image: false,
      ...payload,
    },
  };
};
